import { getUnsentCount } from '../offlineDb';

/**
 * Ask before signing out with scores still on this phone.
 *
 * Nothing is lost by going ahead — the queue keeps each write for the player
 * who made it (`setSyncOwner`) — but nothing will SEND either until they sign
 * back in on this phone, and a scorer who logs out at the 18th green expecting
 * the card to be in would otherwise find out from the organiser. The native
 * confirm is the reversible tier in CLAUDE.md's confirmation rules: declining
 * costs nothing, and accepting is undone by signing back in.
 */
export async function confirmLogoutWithUnsent() {
  let unsent = 0;
  try { unsent = await getUnsentCount(); } catch { /* no IndexedDB: nothing queued */ }
  if (!unsent) return true;
  return window.confirm(
    `${unsent} score${unsent === 1 ? " hasn't" : "s haven't"} been sent yet. `
    + 'They will stay on this phone and send next time you sign in here. Log out anyway?',
  );
}
